import { Component, Inject, OnInit } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-detailsKeyServices',
  templateUrl: './detailsKeyServices.component.html',
  styleUrls: ['./detailsKeyServices.component.scss']
})

export class DetailsKeyServicesComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  spinner: boolean = false;
  OfficeIDList: any = [];
  myOfficeID: any;
  services: any = [];
  
  constructor(public dialogRef: MatDialogRef<DetailsKeyServicesComponent>,
    private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach((oe: any) => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
  
  }

  ngOnInit(): void {
    this.services =this.data.PDPMKeyServices;   
  }

  closePopUp() {
    this.dialogRef.close();
  }

}
